// Saga

// Redux

export function setOnLoginPath(
    path: string | null
): sage.actions.open.ISetOnLoginPath {
    return {
        type: "com.sage.actions.open.ISetOnLoginPath",
        path,
    };
}
